import {
  Box,
  Checkbox,
  InputAdornment,
  styled,
  Typography,
  Link,
} from "@mui/material";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { imagesList } from "../../../constants";
import { happyCustomerInfo } from "../../../constants/happyCustomerData";
import { primary } from "../../../constants/theme";
import { MemoizedButton } from "../../../SDK/button";
import { MemoizedPhoneField } from "../../../SDK/input/phoneInput";
import { checkError } from "../../../SDK/utils/validationHelpers";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import MemoizedVehicleBadges from "../HomePageVehicleThumbnail/vehicleBatch";

const CustomHappyCustomers = styled(Box)(({ theme }) => ({
  //   background: "#FFF9FA",
  ".main-box": {
    margin: "10px",
  },
  ".head-text": {
    padding: "0px 10px",
    fontWeight: 600,
    fontSize: "22px",
    marginTop: "30px",
    marginBottom: "20px",
    paddingLeft: "16px",
  },
  ".image-box": {
    width: "100%",
    padding: "20px 0px",
  },
  ".test-drive-image": {
    width: "100%",
  },

  ".cutomerList": {
    overflowX: "auto",
    display: "flex",
    overflowY: "hidden",
    flexDirection: "row",
    whiteSpace: "nowrap",
    margin: "10px 4px 10px 4px",
    "::-webkit-scrollbar": {
      display: "none",
    },
  },

  ".customer-link": {
    textDecoration: "none",
    color: "inherit",
    display: "block",
    textAlign: "center",
    
    "&:hover": {
      textDecoration: "none",
      color: "inherit",
    },
    
    "&:visited": {
      textDecoration: "none",
      color: "inherit",
    },
    
    "&:active": {
      textDecoration: "none",
      color: "inherit",
    },
  },
}));

const HappyCustomers = ({
  title = "Customers in 10+ Cities Bought from Us",
  isHomePage = false
}) => {
  const [type, setType] = useState(happyCustomerInfo[0]?.type);
  // const [customerData, setVehicleData] = useState(
  //   happyCustomerInfo[customerId ?? 0]
  // );

  const navigate = useRouter();

  const handleSelection = (res) => {
    // setVehicleData(res);
    setType(res?.type);
  };

  const getNavigationUrl = (customerId) => {
    return `/happycustomers/${customerId}`;
  };

  const handleCustomerClick = (e, res) => {
    e.preventDefault();
    handleSelection(res);
    let payload = {
      customer_id: res?.ID,
      customer_name: res?.name,
    };
    sendAnalytics("v2_happy_customer_clicked", payload, "en");
    navigate.push(getNavigationUrl(res?.ID));
  };

  const targetRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        sendAnalytics("v2_scroll_happy_customers", {}, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
  }, [targetRef]);
  return (
    <CustomHappyCustomers>
      <Box className="main-box" id="happy-customers" ref={targetRef}>
        <Box>
          <Typography className="head-text">
            {navigate.pathname === "/" && (
              <span style={{ color: primary?.main }}>4000+ </span>
            )}
            {title}
          </Typography>
        </Box>

        {/* <Box className="image-box">
          <LazyLoadImage
            className="test-drive-image"
            src={imagesList.productRating1}
          />
        </Box> */}
        <Box>
          <Box className="cutomerList">
            {Array.isArray(happyCustomerInfo) && happyCustomerInfo?.map((res, key) => {
              return (
                <Link
                  key={key}
                  href={getNavigationUrl(res?.ID)}
                  className="customer-link"
                  onClick={(e) => handleCustomerClick(e, res)}
                >
                  <Box textAlign={"center"}>
                    <MemoizedVehicleBadges
                      selectedType={type}
                      type={res?.type}
                      thumbnail={res?.thumbnail}
                    />
                    <Typography
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "10px",
                      }}
                    >
                      {res?.name}
                    </Typography>
                  </Box>
                </Link>
              );
            })}
          </Box>
        </Box>
      </Box>
    </CustomHappyCustomers>
  );
};

export default HappyCustomers;
